import React, { useEffect, useState } from "react";
import { ArrowRight, Download } from "lucide-react";
import { toast } from "sonner";
import { getResources } from "../lib/api";
import { Reveal } from "../components/Primitives";

export default function Resources() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getResources()
      .then(setItems)
      .catch(() => toast.error("Could not load resources."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="resources-page">
      <section className="pt-36 pb-16 md:pt-44 md:pb-20 bg-[#120726] grain text-center">
        <div className="container-loft max-w-3xl mx-auto">
          <Reveal>
            <p className="overline mb-5">Resources & Shop</p>
            <h1 className="font-serif text-5xl md:text-7xl font-light leading-[1.03] text-[#EFE7FA]">
              Tools to <span className="text-gradient">heal & grow</span>
            </h1>
            <p className="mt-7 text-lg md:text-xl font-light leading-relaxed text-[#EFE7FA]/75">
              Workbooks, courses, templates, and memberships — thoughtfully crafted to support
              your journey through The 5L Method™.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28 bg-[#1a0d33] pt-16">
        <div className="container-loft">
          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="card-soft h-96 animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {items.map((r, i) => (
                <Reveal key={r.id} delay={i * 0.08}>
                  <div data-testid={`resource-card-${r.id}`} className="card-soft overflow-hidden h-full flex flex-col">
                    <div className="relative h-52 overflow-hidden">
                      <img src={r.cover} alt={r.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                      {r.badge && (
                        <span className="absolute top-4 left-4 bg-[#5B2C83] text-white text-xs tracking-wide px-3 py-1 rounded-full">{r.badge}</span>
                      )}
                    </div>
                    <div className="p-6 flex flex-col flex-1">
                      <span className="overline text-[#4FD6AD]">{r.type}</span>
                      <h3 className="font-serif text-2xl font-light text-[#EFE7FA] mt-2">{r.title}</h3>
                      <p className="mt-3 text-sm font-light leading-relaxed text-[#EFE7FA]/70 flex-1">{r.description}</p>
                      <div className="mt-5 flex items-center justify-between">
                        <span className="font-serif text-2xl text-[#C4A2E8]">${r.price}{r.type === "Membership" && <span className="text-sm text-[#EFE7FA]/50">/mo</span>}</span>
                        <button
                          data-testid={`resource-buy-${r.id}`}
                          onClick={() => toast.success("Checkout is coming soon — thank you for your patience!")}
                          className="btn-emerald text-sm px-5 py-2.5"
                        >
                          {r.type === "Workbook" || r.type === "Template" ? <><Download size={15} /> Get</> : <>Enroll <ArrowRight size={15} /></>}
                        </button>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          )}

          <Reveal delay={0.2}>
            <div className="mt-16 text-center card-soft p-10 max-w-2xl mx-auto">
              <h3 className="font-serif text-3xl font-light text-[#EFE7FA]">More on the way</h3>
              <p className="mt-3 text-[#EFE7FA]/70 font-light">
                New courses, certifications, and digital downloads are added regularly. Join the community
                to be the first to know.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
